


var slideIndex = 1;
// 延迟执行，确保DOM加载完成
document.addEventListener('DOMContentLoaded', function() {
    showSlides(slideIndex);
});
        
function plusSlides(n) {
    showSlides(slideIndex += n);
}
        
function currentSlide(n) {
    showSlides(slideIndex = n);
}
        
function showSlides(n) {
var i;
var slides = document.getElementsByClassName("mySlides");
var dots = document.getElementsByClassName("dot");

// 检查元素是否存在
if (slides.length === 0) {
    return;
}

if (n > slides.length) {slideIndex = 1}    
if (n < 1) {slideIndex = slides.length}
for (i = 0; i < slides.length; i++) {
    if (slides[i] && slides[i].style) {
        slides[i].style.display = "none";  
    }
}
for (i = 0; i < dots.length; i++) {
    if (dots[i] && dots[i].className) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
}
if (slides[slideIndex-1] && slides[slideIndex-1].style) {
    slides[slideIndex-1].style.display = "block";  
}
if (dots[slideIndex-1] && dots[slideIndex-1].className) {
    dots[slideIndex-1].className += " active";
}
}




// smooth effect
// Scroll to specific values
// scrollTo is the same
window.scroll({
    top: 2500, 
    left: 0, 
    behavior: 'smooth'
  });
  
  // Scroll certain amounts from current position 
  window.scrollBy({ 
    top: 100, // could be negative value
    left: 0, 
    behavior: 'smooth' 
  });
  
  // Scroll to a certain element
  var helloElement = document.querySelector('.hello');
  if (helloElement) {
      helloElement.scrollIntoView({ 
        behavior: 'smooth' 
      });
  }


  // Select all links with hashes - 使用原生JavaScript替代jQuery
  document.addEventListener('DOMContentLoaded', function() {
      var hashLinks = document.querySelectorAll('a[href*="#"]');
      hashLinks.forEach(function(link) {
          if (link.href !== '#' && link.href !== '#0') {
              link.addEventListener('click', function(event) {
                  // On-page links
                  if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
                    && 
                    location.hostname == this.hostname
                  ) {
                    // Figure out element to scroll to
                    var hash = this.hash;
                    // 验证 hash 是否是有效的 CSS 选择器（不能包含 / 或其他无效字符）
                    if (hash && hash !== "#" && hash.length > 1 && !hash.includes('/')) {
                        try {
                            var target = document.querySelector(hash) || document.querySelector('[name=' + hash.slice(1) + ']');
                            if (target) {
                                event.preventDefault();
                                target.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        } catch (e) {
                            // 如果 querySelector 失败（无效的选择器），静默忽略
                            console.warn('Invalid selector:', hash);
                        }
                    }
                  }
              });
          }
      });
  });




// 移除slick slider代码，因为页面中没有使用
// $(document).ready(function () {
//     $('.customer-logos').slick({
//         slidesToShow: 6,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 1500,
//         arrows: false,
//         dots: false,
//         pauseOnHover: false,
//         responsive: [{
//             breakpoint: 768,
//             settings: {
//                 slidesToShow: 4
//             }
//         }, {
//             breakpoint: 520,
//             settings: {
//                 slidesToShow: 3
//             }
//         }]
//     });
// });